var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /source/~/lodash/_Symbol.js
// module id = 10
// module chunks = 0